import React, { useEffect, useState } from 'react';

interface BulkExclusionModalProps {
  isOpen: boolean;
  orderReference: string;
  isSaving: boolean;
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

const BulkExclusionModal: React.FC<BulkExclusionModalProps> = ({
  isOpen,
  orderReference,
  isSaving,
  onConfirm,
  onCancel,
}) => {
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setReason('');
      setError('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!reason.trim()) {
      setError('A reason is required');
      return;
    }

    onConfirm(reason.trim());
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
      <div className="bg-white px-4 py-6 md:p-6 rounded-md shadow-lg max-w-sm w-full">
        <h2 className="text-2xl font-bold mb-4">Exclude {orderReference}</h2>
        <p className="text-sm text-gray-600 mb-4">
          This order will be skipped by Bulk Ready for Collection and left off the collection form until
          it is included again. No WhatsApp notification will be sent and the order stays editable.
        </p>
        <form className="space-y-4" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="bulk-exclusion-reason" className="block text-gray-700 mb-1">
              Reason
            </label>
            <input
              id="bulk-exclusion-reason"
              type="text"
              value={reason}
              onChange={e => {
                setReason(e.target.value);
                if (error) setError('');
              }}
              placeholder="e.g. Waiting on a missing item"
              className="w-full px-3 py-2 border rounded"
              maxLength={120}
              autoFocus
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
          </div>
          <div className="flex justify-end space-x-2">
            <button
              type="button"
              onClick={onCancel}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isSaving}
              className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800 disabled:opacity-50"
            >
              {isSaving ? 'Excluding...' : 'Exclude Order'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default BulkExclusionModal;
